import { createFileRoute } from '@tanstack/react-router';
import CollectionsPage from 'src/CollectionsPage/CollectionsPage';
import { requireAuth } from 'src/utils/authGuard';

export const Route = createFileRoute('/library/collections/$collectionId')({
  beforeLoad: () => {
    requireAuth();
  },
  component: CollectionsPage,
});
